import { create } from "zustand";
import { persist } from "zustand/middleware";

interface AviaryStore {
  lastViewId: number | null;
  setLastViewId: (id: number) => void;
}

export const aviaryStore = create<AviaryStore>()(
  persist(
    (set) => ({
      lastViewId: null,
      setLastViewId: (id) => {
        set({ lastViewId: id });
      },
    }),
    { name: "aviary" },
  ),
);
